import { ButtonProps, Button as MuiButton } from '@mui/material';
import React from 'react';
import { IButton } from './interfaces';

export const Button: React.FC<IButton> = ({
  label,
  disabled,
  onClick,
  variant = 'secondary',
}): JSX.Element => {
  const color: ButtonProps['color'] = (() => {
    if (variant === 'secondary') {
      return 'default';
    } else if (variant === 'danger') {
      return 'error';
    }

    return variant;
  })();

  return (
    <MuiButton
      autoFocus
      onClick={onClick}
      disabled={disabled}
      variant={variant === 'secondary' ? 'outlined' : 'contained'}
      size="small"
      color={color}
    >
      {label}
    </MuiButton>
  );
};
